import React, { useEffect, useState } from 'react';
import { ssoService, SSOUser } from '../shared/ssoService';
import './HRDashboard.css';

const HRDashboard: React.FC = () => {
  const [user, setUser] = useState<SSOUser | null>(null);

  useEffect(() => {
    const loadUser = async () => {
      const currentUser = await ssoService.getCurrentUser();
      setUser(currentUser);
    };
    loadUser();
  }, []);

  const handleLogout = async () => {
    await ssoService.logout();
  };

  return (
    <div className="hr-dashboard">
      <header className="dashboard-header">
        <div className="header-content">
          <div className="dashboard-navbar-brand">
            <img src="https://syberkey.com/images/logo.png" alt="SyberKey Logo" className="dashboard-logo-img" />
            <div className="dashboard-brand-text">
              <div className="dashboard-brand-name">
                Syber<span className="brand-yellow">Key</span>
              </div>
            </div>
            <span style={{ marginLeft: '1rem', color: 'var(--muted)', fontSize: '0.9rem' }}>• HR</span>
          </div>
          <div className="user-info">
            {user && <span className="user-email">{user.email}</span>}
            <button onClick={handleLogout} className="logout-btn">Logout</button>
          </div>
        </div>
      </header>

      <main className="dashboard-content">
        <div className="welcome-section">
          <h2>Human Resources Portal</h2>
          <p>Manage employees, leave, and payroll</p>
        </div>

        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-icon">👤</div>
            <div className="stat-info">
              <h3>Total Employees</h3>
              <p className="stat-value">247</p>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">📅</div>
            <div className="stat-info">
              <h3>Pending Leave Requests</h3>
              <p className="stat-value">12</p>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">💰</div>
            <div className="stat-info">
              <h3>Monthly Payroll</h3>
              <p className="stat-value">$245K</p>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">⭐</div>
            <div className="stat-info">
              <h3>Performance Reviews</h3>
              <p className="stat-value">8</p>
            </div>
          </div>
        </div>

        <div className="content-section">
          <h3>Recent Employee Activity</h3>
          <div className="activity-list">
            <div className="activity-item">
              <span className="activity-icon">✅</span>
              <div className="activity-details">
                <strong>John Doe</strong> submitted leave request
                <span className="activity-time">2 hours ago</span>
              </div>
            </div>
            <div className="activity-item">
              <span className="activity-icon">📝</span>
              <div className="activity-details">
                <strong>Jane Smith</strong> completed performance review
                <span className="activity-time">5 hours ago</span>
              </div>
            </div>
            <div className="activity-item">
              <span className="activity-icon">🎉</span>
              <div className="activity-details">
                <strong>Mike Johnson</strong> joined the team
                <span className="activity-time">1 day ago</span>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default HRDashboard;
